module.exports = __webpack_public_path__ + "sgby/img/playGame.6517ae6.png";